<template>
  <div id="about">
  		 <Header msg="/about" />
		<div style='height: 48px;'></div>
		<div class="aboutPage">
			<div :style="{backgroundImage:'url('+require('@/assets/about/aboutUs.jpg')+')'}" class='aboutBanner'>
				<div class='bannerName'>关于橘袋</div>
				<div class='bannerTitle'>{{bannerTitle}}</div>
			</div>
			<div style='position: relative;height:1px;'>
				<div class='reddiv'></div>
			</div>
			
			<div class='aboutBox'>
				
				<div class='aboutLeft'>
						<div class='aboutLeftTxt'>{{title1}}</div>
						<div class='aboutLeftTxt'>{{title2}}</div>
						<img :src="require('@/assets/about/I58A5054@2x.png')" >
						<div class='aboutLeftTxt2'>帮助每一个人<br/>拥有更健康的身体<br/>实现更好的自己</div>
				</div>
				<div class='aboutRight'>
						<div class='aboutRightdiv'></div>
						<img :src="require('@/assets/about/shutterstock_53252755@2x.png')" >
					<!-- 	<div class='nupack'>
							<img :src="require('@/assets/about/nupacks.jpg')" >
						</div> -->
						
				</div>
			</div>
		</div>

  		 <Foot />
  </div>
</template>
<script>
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'


export default {
  name: 'About',
  components: {
      Header,
      Foot,
  },
  data:()=>{
  	return{
  		bannerTitle:"NUTRIPACKS，总部位于美国纽约，是一家专注于发展个性化健康服务的健康科技公司，面向企业和个人提供高品质的综合健康管理服务。",
  		title1:"NUTRIPACKS认为，科学、专业和严谨，是推行现代营养健康理念必须坚守的信念根基。创立之初在纽约总部设立NNRC营养研究中心，凭借15年以上营养研发智慧，不断展开的现代营养学全方位科学研究。同时，NUTRIPACKS还持续投入对新互联科技的研发，依托自身大数据分析和处理能力，研制出领先的临床营养智能AI评估学习系统，帮助专业人士迅速完成营养健康管理评估和决策。 ",
  		title2:"2018年，NUTRIPACKS成功研发出面向个人的个性化定制营养补剂产品。经过严谨的综合测试和大数据优化，2019年这款产品以“橘袋”为名首次进入中国，用户只需花几分钟完成在线专业测试，就能获取按月定制且更适合自身的营养补剂方案，所有营养补剂经过纯天然NPA，NSF认证。未来，NUTRIPACKS会坚持科学持续创新，不断研发更贴近自然的膳食营养补充剂，推广更适合于当地人群的科学膳食建议，以及倡导更合理的自然健康生活方式。"
  	}
  	
  },
  mounted:function(){
  	
  	 $('html,body').animate({scrollTop:0},10);
  },
}
</script>
<style>
#about{
	width: 100%;
	height:100%;
}
.aboutPage{
	
}
.aboutBanner{
	max-width: 100vw;
	width: 100%;
	height:45vw;
	max-height:640px;
	background-repeat: no-repeat;
	background-size: 100%;
	background-position:center;
	-moz-background-size: 100% 100%;
}
.bannerName{
	height:50px;
	font-size:36px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	line-height:50px;
	letter-spacing:2px;
	padding: 16vw 0 80px;
}
.bannerTitle{
	width:466px;
	font-size:18px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(255,255,255,1);
	line-height:25px;
	letter-spacing:1px;
	margin:0 auto;
}

.aboutBox{
	width: 100%;
	max-width: 1440px;
	margin: 0 auto;
	display: flex;
	padding: 7.5vw 100px;
	justify-content: space-between;
	position: relative;
}

.aboutLeft{
	width: 44%;
}
.aboutRight{
	width: 44%;
	position: relative;
}
.aboutLeft img{
	width: 100%;
	max-height:28vw;
}
.aboutLeftTxt{
	font-size:16px;
	font-family:PingFangSC-Light;
	font-weight:300;
	color:rgba(36,36,36,1);
	line-height:32px;
	letter-spacing:1px;
	text-align: left;
	text-indent: 2em;
	margin-bottom: 20px;
}
.aboutLeftTxt2{
	text-align:right;
	font-size:18px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(36,36,36,1);
	line-height:36px;
	letter-spacing:1px;
	padding-top: 72px;
}
.aboutRightdiv{
	height:47vw;
	max-height: 682px;
}
.aboutRight img{
	display: block;
	width: 25vw;
	height:33.5vw;
	max-width: 360px;
	max-height:482px;
}
.nupack{
	position: absolute;
	height:650px;
	width: 60px;
	right: 0;
	top:0;
}
.nupack img{
	width: 100%;
	height:100%;
	display: block;
}

.reddiv{
	position: absolute;
	width: 58px;
	height:11vw;
	min-height:164px;
	background:rgba(194,94,77,1);
	top:7.5vw;
	left: 0;
}
</style>